import { useState } from "react";
import { faqs } from "@/mocks/faq";

export default function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {faqs.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.q}
            className={`rounded-lg border transition-colors ${
              isOpen
                ? "bg-background-50 border-primary-200"
                : "bg-background-50 border-background-200/80"
            }`}
          >
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpenIndex(isOpen ? null : index)}
              className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
            >
              <span className="font-heading font-bold text-sm md:text-base text-foreground-900">
                {item.q}
              </span>
              <i
                className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${
                  isOpen
                    ? "bg-primary-500 text-background-50 ri-subtract-line"
                    : "bg-background-200 text-foreground-600 ri-add-line"
                }`}
              ></i>
            </button>
            {isOpen && (
              <div className="px-4 md:px-5 pb-4 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}